import { render, staticRenderFns } from "./EditorStaffCountViewer.vue?vue&type=template&id=298f7347&scoped=true&"
import script from "./EditorStaffCountViewer.vue?vue&type=script&lang=ts&"
export * from "./EditorStaffCountViewer.vue?vue&type=script&lang=ts&"
import style0 from "./EditorStaffCountViewer.vue?vue&type=style&index=0&id=298f7347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f7347",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VRow})
